/**
 * @file useOpenLegalFile.ts
 * @description «Открыть» файл PDF документа в новой вкладке (phase19.16,
 * SB139, SB143): файл черновика или файл любой редакции.
 *
 * Файл отдаёт API кабинета (`GET /:id/file?source=`) — с cookie и
 * заголовком кабинета вкладки, поэтому прямой ссылкой его не открыть:
 * скачиваем как Blob и показываем по `blob:`-адресу. Вкладка открывается
 * синхронно по нажатию (иначе браузер заблокирует всплывающее окно), адрес
 * ставится после загрузки. Вкладку не дали открыть — файл скачивается.
 */

import { useNotify } from "../../components/ui/NotifyProvider";
import { downloadLegalFile } from "../../lib/api-legal";
import { legalErrorText } from "../../lib/legal/legal-errors";

/** Через сколько освободить `blob:`-адрес (вкладка успевает его прочитать). */
const REVOKE_AFTER_MS = 60_000;

export function useOpenLegalFile(): (docId: string, source: "draft" | number) => void {
  const notify = useNotify();
  return (docId, source) => {
    const tab = window.open("", "_blank");
    // Вкладка с файлом не должна управлять кабинетом через window.opener.
    if (tab) tab.opener = null;
    void downloadLegalFile(docId, source)
      .then(({ blob, filename }) => {
        const url = URL.createObjectURL(blob);
        if (tab) {
          tab.location.href = url;
        } else {
          const link = document.createElement("a");
          link.href = url;
          link.download = filename;
          link.click();
        }
        window.setTimeout(() => URL.revokeObjectURL(url), REVOKE_AFTER_MS);
      })
      .catch((err: unknown) => {
        tab?.close();
        notify.error(legalErrorText(err, "Не удалось открыть файл"));
      });
  };
}
